import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { propTypes } from '../../util/types';
import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
import { useConfiguration } from '../../context/configurationContext';
import {
    LayoutSideNavigation,
    Page,
} from '../../components';

import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../FooterContainer/FooterContainer';
import { isScrollingDisabled, manageDisableScrolling } from '../../ducks/ui.duck';
import css from './FollowCompanyPage.module.css';
import FollowCompanyForm from './FollowCompanyForm';
import { getFollowCompanyData, updateFollower } from './FollowCompanyPage.duck';
import { updateProfile } from '../ProfileSettingsPage/ProfileSettingsPage.duck';

export const FollowCompanyPageComponent = props => {
    const {
        intl,
        currentUser,
        scrollingDisabled,
        onManageDisableScrolling,
        followCompany,
        followCompanyInProgress,
        getFollowCompanyData,
        onUpdateFollower,
        updateFollowerInProgress,
        onUpdateProfile
    } = props;

    const isCompany = currentUser && currentUser.id && currentUser.attributes.profile.publicData.accountType === "company";
    const { pagination } = followCompany || {};
    const { totalItems: noOfFollowed } = pagination || 0;

    // const noOfFollowed = followCompany && followCompany?.users?.length || 0;

    const config = useConfiguration();
    const title = intl.formatMessage({ id: 'FollowCompanyPage.title' }, { marketplaceName: config.marketplaceName });

    const handleUnfollow = (id, companyId
    ) => {
        const payData = {
            follwerId: companyId,
            alreadyFollowerID: id
        }
        onUpdateProfile(payData)
        // onUpdateProfile: (payload) => dispatch(updateProfile(payload)),

        // onUpdateFollower(id);
    }

    return (
        <Page title={title} scrollingDisabled={scrollingDisabled}>
            <LayoutSideNavigation
                className={css.topBarWrapper}
                topbar={
                    <TopbarContainer
                        currentPage="FollowCompanyPage"
                        desktopClassName={css.desktopTopbar}
                        mobileClassName={css.mobileTopbar}
                    />
                }
                sideNav={null}
                useAccountSettingsNav
                currentUser={currentUser}
                currentPage="FollowCompanyPage"
                footer={<FooterContainer />}
            >
                <div className={css.followingHeading}>

                    <h1 className={css.title}>
                        {isCompany ? (
                            <FormattedMessage id="FollowCompanyPage.heading.followers" defaultMessage="Followers" />
                        ) : (
                            <FormattedMessage id="FollowCompanyPage.heading.following" defaultMessage="Following" />
                        )}
                        {(followCompanyInProgress || updateFollowerInProgress) ? null : (
                            <span className={css.supSquare}>{noOfFollowed}</span>
                        )}
                    </h1>

                </div>



                <FollowCompanyForm
                    followCompany={followCompany}
                    followCompanyInProgress={followCompanyInProgress}
                    handleUnfollow={handleUnfollow}
                    currentUser={currentUser}
                    updateFollowerInProgress={updateFollowerInProgress}
                />

            </LayoutSideNavigation>
        </Page >
    );
};

FollowCompanyPageComponent.defaultProps = {
    currentUser: null,
};

const { bool, func, shape } = PropTypes;

FollowCompanyPageComponent.propTypes = {
    currentUser: propTypes.currentUser,
    scrollingDisabled: bool.isRequired,
    intl: intlShape.isRequired,
    history: shape({
        push: func.isRequired,
    }).isRequired,
};

const mapStateToProps = state => {
    const { currentUser } = state.user;
    const { followCompany, followCompanyInProgress, updateFollowerInProgress } = state.FollowCompanyPage;
    return {
        currentUser,
        scrollingDisabled: isScrollingDisabled(state),
        followCompany,
        followCompanyInProgress,
        updateFollowerInProgress
    };
};

const mapDispatchToProps = dispatch => ({
    onManageDisableScrolling: (componentId, disableScrolling) =>
        dispatch(manageDisableScrolling(componentId, disableScrolling)),
    getFollowCompanyData: (companyId, page, isCompany) =>
        dispatch(getFollowCompanyData(companyId, page, isCompany)),
    onUpdateFollower: (followerId) =>
        dispatch(updateFollower(followerId)),
    onUpdateProfile: (payload) => dispatch(updateProfile(payload)),
});

const FollowCompanyPage = compose(
    connect(
        mapStateToProps,
        mapDispatchToProps
    ),
    withRouter,
    injectIntl
)(FollowCompanyPageComponent);

export default FollowCompanyPage;
